module.exports = __webpack_public_path__ + "img/google-play-badge-sm.0b9f6dc7.png";